import React, { useRef } from "react";
import { Table, Row, Col } from "reactstrap";
import { useFieldArray } from "react-hook-form";
import ProductCard from "./ProductCard";

function ProductTable(props) {
  const { getValues, discountType, control, submitLoading } = props;
  const productRef = useRef();

  const { buy_products, get_products } = getValues();

  const { remove: removeBuyProduct } = useFieldArray({
    name: "buy_products",
    control,
  });

  const { remove: removeGetProduct } = useFieldArray({
    name: "get_products",
    control,
  });

  const handleRemoveProduct = (index, isBuyProduct) => {
    if (isBuyProduct) {
      removeBuyProduct(index);
    } else {
      removeGetProduct(index);
    }
  };

  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      <Table bordered style={{ width: '100%' }}>
        <thead>
          <tr>
            <th
              style={{
                textAlign: "center !important",
                borderWidth: "0.5px",
                borderColor: "#e0e0e0",
                borderStyle: "solid",
                backgroundColor: "white",
                fontSize: "12px !important",
              }}
            >
              {discountType === 1 ? "Buy/Get Products" : discountType === 2 ? "Customer Buy Products" : "Buy Products"}
            </th>
            {discountType === 2 && <th className="text-center align-middle">Customer Get Products</th>}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="align-top" style={{ width: "50%" }}>
              <Row className="p-2 min-vh-25">
                {buy_products.map((item, index) => (
                  <Col key={`${index}_buy`} md={discountType === 2 ? 4 : 3} data-product={item.id} className="mb-3" style={{ paddingRight: 4 }}>
                    <ProductCard item={item} onRemove={() => handleRemoveProduct(index, true)} submitLoading={submitLoading}/>
                  </Col>
                ))}
              </Row>
            </td>

            {discountType === 2 && (
              <td
                className="align-top"
                style={{
                  width: "50%",
                  textAlign: "center !important",
                  borderWidth: "0.5px",
                  borderColor: "#e0e0e0",
                  borderStyle: "solid",
                  backgroundColor: "white",
                  fontSize: "12px !important",
                }}
              >
                <Row className="p-2 min-vh-25">
                  {get_products.map((item, index) => (
                    <Col key={`${index}_get`} md={discountType === 2 ? 4 : 3} data-product={item.id} className="mb-3" style={{ paddingRight: 4 }}>
                      <ProductCard item={item} onRemove={() => handleRemoveProduct(index, false)} submitLoading={submitLoading}/>
                    </Col>
                  ))}
                </Row>
              </td>
            )}
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

export default ProductTable;
